<template>
  <div class="home">
    <Message/>
    <Search/>
    <Customer/>
    <Brand/>
    <SloganCard :bg-color="'#1E55AE'">
      <h1 style="font-size: 36px;" data-aos="fade-right" data-aos-duration="1500">
        <i>为客户创造价值</i><br/>
        <i>诚信为本·创新为质</i>
      </h1>
      <div data-aos="fade-left" data-aos-duration="1500">
        <span style="font-size: 16px;">服务热线：</span><br/>
        <span style="font-size: 30px;">{{ this.firstContact.telephone }}</span>
      </div>
    </SloganCard>
    <Reasons/>
    <SloganCard :bg-color="'#1C1A1D'">
        <h1 style="font-size: 36px;" data-aos="fade-right" data-aos-duration="1500">
          <i>快中有节奏</i><br/>
          &nbsp;&nbsp;<i>精中有格致</i>
        </h1>
        <div data-aos="fade-left" data-aos-duration="1500">
          <span style="font-size: 16px;">服务热线：</span><br/>
          <span style="font-size: 30px;">{{ this.firstContact.telephone }}</span>
        </div>
    </SloganCard>
    <Business/>
    <About/>
  </div>
</template>

<script>
// import Banner from './Banner'
import Message from './Message';
import Search from './Search'
import Brand from './Brand'
import Customer from './Customer'
import Reasons from './Reasons'
import Business from '@/views/About/Business'
import About from './About'
// import News from './News'
import SloganCard from '@/components/SloganCard'
import {mapState} from "vuex";

export default {
  name: 'Home',
  components: {Message,  Search, Brand, Customer, SloganCard, Reasons, Business, About},
  computed: {
    ...mapState('about', ['firstContact'])
  },
}
</script>

<style scoped lang="less">
.home {
  width: 100%;
}
</style>
